export default {
    header: {
        inicio: 'Inicio',
        empresa: 'Nuestra empresa',
        aliado: 'Aliados',
        servicios: 'Servicios',
        blog: 'Blog',
        contacto: 'Contacto',
        button: 'Acceso Aplicativo Web SST',
        arl: 'ARL',
        empresas: 'Empresariales',
        personas: 'Personales y Familia'
    },
    index: {
        formtext: 'La ',
        formtext2: ' de tu empresa y la de tus trabajadores es lo mas ',
        formtext3: ' para nosotros',
        spam1: 'seguridad',
        spam2: 'importante'
    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js